import React from 'react';
import { twMerge } from 'tailwind-merge';

type SectionProps = {
  className?: string;
  title?: React.ReactNode;
  actions?: React.ReactNode;
  subtitle?: React.ReactNode;
  children?: React.ReactNode;
};

const Section: React.FC<SectionProps> = ({
  title,
  subtitle,
  actions,
  className,
  children,
}) => {
  return (
    <section
      className={twMerge(
        'flex flex-col gap-y-md border border-active rounded-sm p-xl bg-content',
        className
      )}
    >
      {(title || actions) && (
        <div className="flex flex-row items-center justify-between">
          {!!title && (
            <h3 className="text-medium font-semibold text-text">{title}</h3>
          )}
          {!!actions && <div className="ml-auto">{actions}</div>}
        </div>
      )}
      {!!subtitle && <p className="text-small text-textLight">{subtitle}</p>}
      {children}
    </section>
  );
};

export default React.memo(Section) as typeof Section;
